import { jwtDecode } from "jwt-decode";

const userData = {
  data() {
    return {
      userData: null,
      userId: null,
      userFullName: null,
      userName: null,
      userLevel: null,
      userRole: null,
      userSublevel: null,
      userAccess: null,
      userKab: null,
      userProv: null,
      userToken: null,
      userPhoto: "../assets/img/user.png",
    };
  },
  created() {
    const userData = localStorage.getItem("userData");
    if (userData) {
      this.userData = JSON.parse(userData);
      this.userFullName = this.userData.nama;
      this.userToken = this.userData.token;
      const decodedToken = jwtDecode(this.userData.token);
      this.userId = decodedToken.id;
      this.userName = decodedToken.username;
      this.userLevel = decodedToken.role;
      this.userRole = decodedToken.role;
      this.userSublevel = decodedToken.sublevel;
      this.userAccess = decodedToken.id_kab;
      this.userKab = decodedToken.id_kab || null;
      this.userProv = decodedToken.id_prov || this.userKab?.slice(0, 2) || "72";
    }
  },
};

export default userData;
